const Cooperation = () =>
  import('../views/CooperationManage/cooperation/index.vue');
const Add = () =>
  import('../views/CooperationManage/cooperation/pages/addAndEdit.vue');

const Agreement = () =>
  import('../views/CooperationManage/agreement/index.vue');
const newAgreement = () =>
  import('../views/CooperationManage/agreement/pages/addAndEdit.vue');
const Details = () =>
  import('../views/CooperationManage/agreement/pages/details.vue');
export default [
  {
    path: '/cooperation',
    name: '合作机构',
    component: Cooperation,
    meta: [{ name: '合作机构' }],
  },
  {
    path: '/cooperation/details',
    name: '查看机构',
    component: Add,
    meta: [{ name: '合作机构', path: '/cooperation' }, { name: '查看机构' }],
  },
  {
    path: '/agreement',
    name: '推广计划',
    component: Agreement,
    meta: [{ name: '推广计划' }],
  },
  {
    path: '/agreement/add',
    name: '新增计划',
    component: newAgreement,
    meta: [{ name: '推广计划', path: '/agreement' }, { name: '新增计划' }],
  },
  {
    path: '/agreement/edit',
    name: '编辑计划',
    component: newAgreement,
    meta: [{ name: '合作计划', path: '/agreement' }, { name: '编辑计划' }],
  },
  {
    path: '/agreement/details',
    name: '查看协议',
    component: Details,
    meta: [{ name: '合作协议', path: '/agreement' }, { name: '查看协议' }],
  },
];
